import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageModel } from 'src/app/core/models/page.model';
import { BaseService } from 'src/app/core/services/base.service';
import { HeadhunterFilterModel } from '../models/headhunter-filter.model';
import { HeadhunterModel } from '../models/headhunter.model';

@Injectable({
  providedIn: 'root'
})
export class HeadhunterService extends BaseService {
  private baseUrl = '/headhunter';

  getData(after: string, before: string, pageSize: number): Observable<HeadhunterModel[]> {
    const params = new HttpParams().append('after', after).append('before', before).append('pageSize', String(pageSize));
    return this.baseGetWithParams<HeadhunterModel[]>(`${this.baseUrl}/portal/pesquisar`, params);
  }

  getDataByFilter(filtro: HeadhunterFilterModel): Observable<PageModel<HeadhunterModel>> {
    const filtroHelper = {};

    for (const key in filtro) {
      if (filtro[key] != null && filtro[key] != undefined) {
        filtroHelper[key] = filtro[key];
      }
    }

    const params = filtroHelper ? new HttpParams({ fromObject: filtroHelper }) : new HttpParams();

    return this.baseGetWithParams<PageModel<HeadhunterModel>>(`${this.baseUrl}/portal/pesquisar/filtro`, params);
  }
}
